module.exports = __webpack_public_path__ + "img/privilege_3_img1.121b4389.png";